import { AxiosInstance } from 'axios'
import { UserRequestParams } from '/@src/models/api'
import { ComposerTranslation, useI18n } from 'vue-i18n'
import { themeColors } from '/@src/utils/themeColors'
import dayjs from 'dayjs'
import { fetchUserList } from '/@src/api/userRepo'
import { ref } from 'vue'
import * as en from 'apexcharts/dist/locales/en.json'
import * as cn from 'apexcharts/dist/locales/zh-cn.json'
import useApi from "/@src/composable/useApi";

export default function useGetUserListRecentChart() {
  const userChartOptions = ref({})
  const { t, locale } = useI18n()
  const api = useApi()
  const params: UserRequestParams = {
    limit: 1000,
  }
  const getUserChart = async () => {
    await fetchUserList(api, params).then((value) => {
      const series = new Array<number>()
      let loopDate: Date
      let index = 0
      let start: Date = new Date()
      value.list.reverse().map((it) => {
        if (!loopDate) {
          series.push(1)
          loopDate = new Date(it!!.created_at)
          start = new Date(it!!.created_at)
        } else {
          const userDate = new Date(it!!.created_at)
          if (
            userDate.getMonth() === loopDate.getMonth() &&
            userDate.getDate() === loopDate.getDate()
          ) {
            series[index] = series[index] + 1
          } else {
            while (
              userDate.getMonth() !== loopDate.getMonth() ||
              userDate.getDate() !== loopDate.getDate()
            ) {
              index++
              loopDate = new Date(loopDate.getTime() + 24 * 3600 * 1000)
              if (
                userDate.getMonth() === loopDate.getMonth() &&
                userDate.getDate() === loopDate.getDate()
              ) {
                series.push(1)
              } else {
                series.push(0)
              }
            }
          }
        }
      })
      if (value.list.length > 0) {
        userChartOptions.value = setupUserChartOption(
          t,
          locale.value,
          series,
          start
        )
      }
    })
  }
  return {
    userChartOptions,
    getUserChart,
  }
}

function setupUserChartOption(
  t: ComposerTranslation,
  locale: string,
  seriesData: number[],
  start: Date
) {
  return {
    chart: {
      id: 'userAnalytics',
      group: 'dashboardChart',
      type: 'area',
      height: 130,
      defaultLocale: locale.toLocaleLowerCase(),
      locales: [en, cn],
      sparkline: {
        enabled: true,
      },
    },
    colors: [themeColors.danger],
    stroke: {
      width: [2],
      curve: 'straight',
    },
    fill: {
      opacity: 1,
    },
    series: [
      {
        name: t('text-series-user'),
        data: seriesData,
      },
    ],
    labels: [...Array(seriesData.length).keys()].map((n) => {
      return dayjs(new Date(start.getTime() + 3600 * 1000 * 24 * n)).format(
        'YYYY-MM-DD'
      )
    }),
    yaxis: {
      min: 0,
      labels: {
        minWidth: 100,
      },
    },
    xaxis: {
      type: 'datetime',
    },
    title: {
      text: t('title-charts-new-user'),
      offsetX: 5,
      style: {
        fontSize: '24px',
        cssClass: 'apexcharts-yaxis-title',
        color: themeColors.lightText,
      },
    },
    subtitle: {
      offsetX: 5,
      style: {
        fontSize: '24px',
        fontWeight: '600',
        cssClass: 'apexcharts-yaxis-title',
      },
    },
  }
}
